import React, { useEffect, useState } from 'react'
import { ComponentCardForm } from '../../../common/types/cardForm'
import { FGeneralSettings } from '../../../common/types/api/report'
import Text, { GeneralTextInputType } from '../../../common/components/GeneralTextInput/generalTextInput'
import List from '../../../common/components/SimpleInputs/BooleanList'
import styled from 'styled-components'
import { card } from '../../../common/components/CardEditor/index'
import { getGeneralSettings, setGeneralSettings } from './helper'
import i18n from 'live/services/i18n';

export function GeneralSettings({
    editMode,
    validations,
    formObject,
    onChange
}: ComponentCardForm<FGeneralSettings>): JSX.Element {
    const { enabled, title, description } = formObject

    return (
        <Content
            tabIndex={0}
            onFocus={() => {
                editMode = true
                onChange({ enabled, title, description })
            }}
        >
            <div className={'generalSettings--firstRow'}>
                <Text
                    title={i18n('Instance Name')}
                    placeholder={'Ex.: Profit statistics'}
                    required={true}
                    tooltip={
                        i18n('The name chosen here will be the one that will appear in the list of reports (on the previous screen).')
                    }
                    value={title}
                    editMode={editMode}
                    variant="secondary"
                    error={validations?.includes(i18n('Instance name'))}
                    onChange={text => {
                        onChange({ title: text, enabled, description })
                    }}
                    border={true}
                ></Text>
                <List
                    onChange={status => onChange({ title, enabled: status, description })}
                    editMode={editMode}
                    tooltip={i18n('If this session is marked as "inactive", even after published, reports will not be sent.')}
                    required={true}
                    title={'Status'}
                    value={enabled}
                />
            </div>
            <div className={'generalSettings--secondRow'}>
                <Text
                    title={i18n('Report description')}
                    placeholder={i18n('Write here any useful information')}
                    required={false}
                    tooltip={
                        i18n('The information written here is just for user\'s use, it does not affects the process.')
                    }
                    value={description}
                    editMode={editMode}
                    variant="secondary"
                    onChange={text => {
                        onChange({ title, enabled, description: text })
                    }}
                    inputType={GeneralTextInputType.AREA}
                ></Text>
            </div>
        </Content>
    )
}
const Content = styled.div`
    .generalSettings {
        &--firstRow {
            display: flex;
            > div {
                flex: 1;
                padding-left: 2%;
                padding-top: 1%;
                padding-bottom: 1%;
                padding-right: 1%;
                vertical-align: center;
            }
        }
        &--secondRow { 
            display: flex;
            > div {
                flex: 1;
                padding-left: 2%;
                padding-top: 1%;
                padding-bottom: 1%;
                padding-right: 1%;
                vertical-align: center;
            }
        }
    }
`

export default card<FGeneralSettings>({
    title: i18n('GENERAL SETTINGS'),
    get: getGeneralSettings,
    set: setGeneralSettings
})(GeneralSettings)
